module.exports = __webpack_public_path__ + "static/img/17.669d5d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/17.jpg
// module id = kYv/
// module chunks = 0